module.exports = __webpack_public_path__ + "static/media/digital_marketing_landingpage.a1631296.webp";